(function leadModalEvents(global) {
  'use strict';

  const isTouchScreen = Object.prototype.hasOwnProperty.call(global, 'ontouchstart');
  const eventToAttach = isTouchScreen ? 'touchend' : 'click';
  const onPageLeadButton = document.querySelector('[data-on-page-button]');

  function setAttributesToDataLayer(event) {
    const target = event.target;
    if (!target.dataset.leadButtonClicked) {
      return;
    }
    const dataset = target.dataset;
    const leadEvents = {
      ButtonNameClicked: dataset.leadButtonClicked,
      ClickTarget: dataset.leadClickTarget,
      Position: dataset.leadPosition,
      GenerateLeadFrom: dataset.leadGenerateFrom,
      ButtonNameSource: dataset.leadButtonNameSource
    };

    if (!global.NewHomeSource ||
      !global.NewHomeSource.Modules ||
      !global.NewHomeSource.Modules.tagManager) {
      return;
    }
    global.NewHomeSource.Modules.tagManager.setDataLayerValue('leadEvents', leadEvents);
  }

  document.addEventListener(eventToAttach, setAttributesToDataLayer);
  if (onPageLeadButton) {
    onPageLeadButton.addEventListener(eventToAttach, setAttributesToDataLayer);
  }
}(window));
